// Externals
import React from "react";
//import { Redirect } from 'raviger';

// Components
import Welcome from "../pages/Welcome";
// import Instructions from '../pages/Instructions';
import Questionaire from "../pages/Questionaire";
import EndScreen from "../pages/EndScreen";
import WaitScreen from "../pages/WaitScreen";
import Matches from "../pages/Matches";
import Profile from "../pages/Profile";
import AlmostThere from "../pages/AlmostThere";

// Routes
const Routes = {
	"/": () => <Welcome />,
	"/questions/": () => <Questionaire questionId={1} />,
	"/questions/:n": ({ n }) => <Questionaire questionId={n} />,
	"/finish": () => <AlmostThere />,
	"/wait": () => <WaitScreen />,
	"/pet-profile/:id": ({ id }) => <Profile petID={id} />,
	"/results": () => <EndScreen />,
	"/matches": () => <Matches />,
};

// Export
export default Routes;
